var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-statements */
import React, { useEffect, useRef, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSetAtom } from 'jotai';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

import { Translate, t } from "../../../../../I18N";


import { FetchResponseError } from "../../../../../../shared/JSONRequest";


import * as filesAPI from "../../../../api/files";
import * as entitiesAPI from "../../../../api/entities";
import { secondsToISODate } from "../../../../shared/dateHelpers";
import { Button, Sidepanel } from "../../../../Components/UI";
import { InputField } from "../../../../Components/Forms";
import { PDF, selectionHandlers } from "../../../../Components/PDFViewer";
import { notificationAtom } from "../../../../atoms";var









HighlightColors = /*#__PURE__*/function (HighlightColors) {HighlightColors["CURRENT"] = "#B1F7A3";HighlightColors["NEW"] = "#F27DA5";return HighlightColors;}(HighlightColors || {});




const getFormValue = (
suggestion,
entity,
type) =>
{
  let value;

  if (!suggestion || !entity) {
    return value;
  }

  if (suggestion.propertyName === 'title' && entity.title) {
    value = entity.title;
  }

  if (suggestion.propertyName !== 'title' && entity.metadata) {
    const entityMetadata = entity.metadata[suggestion.propertyName];
    value = entityMetadata !== null && entityMetadata !== void 0 && entityMetadata.length ? entityMetadata[0].value : '';

    if (type === 'date' && value) {
      const dateString = secondsToISODate(value);
      value = dateString;
    }
  }

  return value;
};

const getPropertyData = (suggestion, template) => {
  let propertyLabel = template !== null && template !== void 0 && template._id ? t(template._id, 'Title', 'Title', false) : 'Title';
  let propertyType = 'text';
  let propertyId;
  let isRequired = true;

  if (suggestion && (suggestion === null || suggestion === void 0 ? void 0 : suggestion.propertyName) !== 'title') {var _property$_id;
    const property = template === null || template === void 0 ? void 0 : template.properties.find((prop) => prop.name === (suggestion === null || suggestion === void 0 ? void 0 : suggestion.propertyName));

    propertyLabel = t(template === null || template === void 0 ? void 0 : template._id, property === null || property === void 0 ? void 0 : property.label, property === null || property === void 0 ? void 0 : property.label, false);
    propertyId = property === null || property === void 0 ? void 0 : (_property$_id = property._id) === null || _property$_id === void 0 ? void 0 : _property$_id.toString();
    isRequired = (property === null || property === void 0 ? void 0 : property.required) || false;

    if ((property === null || property === void 0 ? void 0 : property.type) === 'numeric') {
      propertyType = 'number';
    }

    if ((property === null || property === void 0 ? void 0 : property.type) === 'date') {
      propertyType = 'date';
    }
  }

  return { propertyLabel, propertyType, isRequired, propertyId };
};

const loadSidepanelData = async ({ fileId, entityId, language }) => {
  const [file, entity] = await Promise.all([
  filesAPI.getById(fileId),
  entitiesAPI.getById({ _id: entityId, language })]
  );

  return { file: file[0], entity: entity[0] };
};

const handleFileSave = async (file, newSelections) => {
  if (file && newSelections) {
    const fileToSave = _objectSpread({}, file);
    fileToSave.extractedMetadata = newSelections;
    return filesAPI.update(fileToSave);
  }

  return undefined;
};

const handleEntitySave = async (
entity,
propertyName,
metadata,
fieldHasChanged) =>
{
  if (!fieldHasChanged || !entity || !propertyName) {
    return undefined;
  }

  let data;

  if (propertyName === 'title' && typeof metadata === 'string') {
    data = { title: metadata };
  } else {
    data = { properties: [{ [propertyName]: metadata }] };
  }

  const entityToSave = entitiesAPI.formatter.update(entity, data);

  return entitiesAPI.save(entityToSave);
};

const coerceValue = async (
propertyType,
text,
documentLanguage = 'en') =>
{
  if (propertyType === 'date' && !Number.isNaN(text === null || text === void 0 ? void 0 : text.valueOf())) {
    return entitiesAPI.coerceValue(text, 'date', documentLanguage);
  }

  if (propertyType === 'number' && typeof text === 'string') {
    return entitiesAPI.coerceValue(text.trim(), 'numeric', documentLanguage);
  }

  return undefined;
};

const PDFSidepanel = ({
  showSidepanel,
  setShowSidepanel,
  suggestion,
  onEntitySave
}) => {
  const { templates } = useLoaderData();



  const pdfContainerRef = useRef(null);
  const [pdf, setPdf] = useState();
  const [pdfContainerHeight, setPdfContainerHeight] = useState(0);
  const [selectedText, setSelectedText] = useState();
  const [selectionError, setSelectionError] = useState();
  const [highlights, setHighlights] = useState();
  const [selections, setSelections] = useState(undefined);
  const [labelInputIsOpen, setLabelInputIsOpen] = useState(true);
  const [entity, setEntity] = useState();
  const setNotifications = useSetAtom(notificationAtom);

  const entityTemplate = templates.find((template) => template._id === (suggestion === null || suggestion === void 0 ? void 0 : suggestion.entityTemplateId));
  const { propertyLabel, propertyType, isRequired, propertyId } = getPropertyData(
    suggestion,
    entityTemplate
  );

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isDirty, isSubmitting }
  } = useForm({
    values: {
      field: getFormValue(suggestion, entity, propertyType)
    }
  });

  useEffect(() => {
    if (suggestion) {
      loadSidepanelData(suggestion).
      then(({ file, entity: suggestionEntity }) => {
        setPdf(file);
        setEntity(suggestionEntity);
      }).
      catch((e) => {
        throw e;
      });
    }

    return () => {
      setPdf(undefined);
      setEntity(undefined);
    };
  }, [suggestion]);

  useEffect(() => {
    if (pdf !== null && pdf !== void 0 && pdf.extractedMetadata && suggestion && showSidepanel) {
      setSelectedText(undefined);
      setHighlights(
        selectionHandlers.getHighlightsFromFile(
          pdf.extractedMetadata,
          suggestion.propertyName,
          HighlightColors.CURRENT
        )
      );
    }

    if (pdfContainerRef.current) {
      const { height } = pdfContainerRef.current.getBoundingClientRect();
      setPdfContainerHeight(height);
    }

    return () => {
      setSelectedText(undefined);
      setSelectionError(undefined);
      setHighlights(undefined);
      setSelections(undefined);
      setValue('field', undefined, { shouldDirty: false });
    };
  }, [pdf, setValue, showSidepanel, suggestion]);

  const onSubmit = async (value) => {
    let metadata = value.field;

    if (propertyType === 'date' && isDirty && metadata) {var _await$coerceValue;
      metadata = (_await$coerceValue = await coerceValue('date', metadata, (pdf === null || pdf === void 0 ? void 0 : pdf.language) || 'en')) === null || _await$coerceValue === void 0 ? void 0 : _await$coerceValue.value;
    }

    const [savedFile, savedEntity] = await Promise.all([
    handleFileSave(pdf, selections),
    handleEntitySave(entity, suggestion === null || suggestion === void 0 ? void 0 : suggestion.propertyName, metadata, isDirty)]
    );

    if (savedFile instanceof FetchResponseError || savedEntity instanceof FetchResponseError) {
      const details =
      (savedFile === null || savedFile === void 0 ? void 0 : savedFile.json.prettyMessage) || (
      savedEntity === null || savedEntity === void 0 ? void 0 : savedEntity.json.prettyMessage);

      setNotifications({ type: 'error', text: 'An error occurred', details });
    } else if (savedFile || savedEntity) {
      if (savedFile) {
        setPdf(savedFile);
      }

      if (savedEntity) {
        setEntity(savedEntity);
        onEntitySave(savedEntity);
      }

      setNotifications({ type: 'success', text: 'Saved successfully.' });
    }

    setShowSidepanel(false);
  };

  const handleClickToFill = async () => {
    if (selectedText) {
      setHighlights(
        selectionHandlers.getHighlightsFromSelection(selectedText, HighlightColors.NEW)
      );
      setSelections(
        selectionHandlers.updateFileSelection(
          { name: (suggestion === null || suggestion === void 0 ? void 0 : suggestion.propertyName) || '', id: propertyId },
          pdf === null || pdf === void 0 ? void 0 : pdf.extractedMetadata,
          selectedText
        )
      );

      if (propertyType === 'date' || propertyType === 'number') {
        const coercedValue = await coerceValue(propertyType, selectedText.text, pdf === null || pdf === void 0 ? void 0 : pdf.language);

        if (!(coercedValue !== null && coercedValue !== void 0 && coercedValue.success)) {
          setSelectionError('Value cannot be transformed to the correct type');
        }

        if (coercedValue !== null && coercedValue !== void 0 && coercedValue.success) {
          setValue('field', secondsToISODate(coercedValue.value), { shouldDirty: true });
          setSelectionError(undefined);
        }
      } else {
        setValue('field', selectedText.text, { shouldDirty: true });
      }
    }
  };

  const renderInputTextLabel = (
  type) => {var _errors$field;return /*#__PURE__*/(

      _jsx("div", { className: "flex gap-2 p-4" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "grow" }, void 0, /*#__PURE__*/
      React.createElement(InputField, _extends({
        clearFieldAction: () => {
          setValue('field', '');
        },
        id: propertyLabel,
        label: propertyLabel,
        hideLabel: true,
        type: type,
        hasErrors: ((_errors$field = errors.field) === null || _errors$field === void 0 ? void 0 : _errors$field.type) === 'required' || !!selectionError },
      register('field', {
        required: isRequired,
        valueAsDate: propertyType === 'date' || undefined
      }))
      )
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Button, {
        type: "button",
        styling: "outline",
        onClick: async () => handleClickToFill(),
        disabled: !(selectedText !== null && selectedText !== void 0 && selectedText.selectionRectangles.length) || isSubmitting }, void 0, /*#__PURE__*/

      _jsx(Translate, { className: "" }, void 0, "Click to fill")
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "sm:text-right", "data-testid": "ix-clear-button-container" }, void 0, /*#__PURE__*/
      _jsx(Button, {
        type: "button",
        styling: "outline",
        disabled: Boolean(!highlights) || isSubmitting,
        onClick: () => {
          setHighlights(undefined);
          setSelections(
            selectionHandlers.deleteFileSelection(
              { name: (suggestion === null || suggestion === void 0 ? void 0 : suggestion.propertyName) || '' },
              pdf === null || pdf === void 0 ? void 0 : pdf.extractedMetadata
            )
          );
        } }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Clear")
      )
      )
      ));};


  const renderLabel = () => {
    switch (propertyType) {
      case 'text':
      case 'date':
      case 'number':
        return renderInputTextLabel(propertyType);
      default:
        return '';
    }
  };

  return /*#__PURE__*/(
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      size: "large",
      title: pdf === null || pdf === void 0 ? void 0 : pdf.originalname,
      closeSidepanelFunction: () => setShowSidepanel(false) }, void 0, /*#__PURE__*/

    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx("form", {
      id: "ixpdfform",
      className: "flex flex-col h-full gap-4 pb-0",
      onSubmit: handleSubmit(onSubmit) }, void 0, /*#__PURE__*/

    React.createElement("div", { ref: pdfContainerRef, className: "md:m-auto md:w-[95%] grow" },
    pdf && /*#__PURE__*/
    _jsx(PDF, {
      fileUrl: `/api/files/${pdf.filename}`,
      highlights: highlights,
      onSelect: (selection) => {
        if (!selection.selectionRectangles.length) {
          setSelectionError('Could not detect the area for the selected text');
          setSelectedText(undefined);
        } else {
          setSelectionError(undefined);
          setSelectedText(selection);
        }
      },
      size: {
        height: `${pdfContainerHeight}px`
      },
      scrollToPage: !selectedText ? Object.keys(highlights || {})[0] : undefined }
    )

    )
    ), ' '
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "py-0 border border-b-0 border-l-0 border-r-0 border-gray-200 border-t-1" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex px-4 py-2" }, void 0, /*#__PURE__*/
    _jsx("p", { className: selectionError ? 'text-pink-600 grow' : 'grow' }, void 0, /*#__PURE__*/
    _jsx("span", { className: "uppercase" }, void 0, propertyLabel), ' ',
    selectionError && /*#__PURE__*/_jsx("span", {}, void 0, selectionError)
    ), /*#__PURE__*/
    _jsx("span", { onClick: () => setLabelInputIsOpen((old) => !old), className: "cursor-pointer" }, void 0,
    labelInputIsOpen ? /*#__PURE__*/_jsx(ChevronDownIcon, { width: 20 }) : /*#__PURE__*/_jsx(ChevronUpIcon, { width: 20 })
    )
    ),
    labelInputIsOpen && renderLabel(), /*#__PURE__*/
    _jsx("div", { className: "flex justify-end gap-2 px-4 py-2 border border-b-0 border-l-0 border-r-0 border-gray-200 border-t-1" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      styling: "outline",
      disabled: isSubmitting,
      onClick: () => {
        setShowSidepanel(false);
        reset();
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { type: "submit", form: "ixpdfform", disabled: isSubmitting, color: "success" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Accept")
    )
    )
    )
    ));

};

export { PDFSidepanel };